export { default as LoyaltyImageWidget } from './loyalty-image-widget';
